import BaseView from '@/views/index/base-view';
export default BaseView.extend({});
